export const AccountRegions = {
    'KE': {
        country: 'Kenya',
        countryCode: 'KE',
        currency: 'KES'
    },
    'US': {
        country: 'United States',
        countryCode: 'US',
        currency: 'USD'
    }
};
export const DefaultAccountRegionId = 'US';
export const DefaultRegion = AccountRegions[DefaultAccountRegionId];
export function getCurrencyForRegion(regionId) {
    if (!regionId) {
        return DefaultRegion.currency;
    }
    if (regionId in AccountRegions) {
        return AccountRegions[regionId].currency;
    }
    return DefaultRegion.currency;
}
//# sourceMappingURL=regions.js.map